import { useContext } from "react"
import PropTypes from "prop-types"
import { ErrorBoundary } from "@sentry/react"
import { useAccountAlias } from "resources/account"
import { AiContext } from "../../context/ai-context"
import { ToggleButton } from "./toggle-button"
import { AiTeammateButtonContent } from "./button-content"
import "./style.scss"

export default function AiTeammateWithButtonToggle({ size = "medium", className = "" }) {
  const context = useContext(AiContext)
  const accountAlias = useAccountAlias()

  const errorFallback = (
    <ToggleButton
      size={size}
      className={className}
      disabled
      tooltip="Unable to load AI Teammate. Try refreshing the page or contact support."
    />
  )

  if (!context) {
    return errorFallback
  }

  return (
    <ErrorBoundary fallback={errorFallback}>
      <AiTeammateButtonContent key={accountAlias} size={size} className={className} context={context} />
    </ErrorBoundary>
  )
}

AiTeammateWithButtonToggle.propTypes = {
  size: PropTypes.oneOf(["small", "medium"]),
  className: PropTypes.string,
}
